import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { CadastroConsultaRequest, Types } from './types';

// ACTIONS
import { cadastroConsultaSuccess, cadastroConsultaFailure } from './actions';

function* cadastroConsultaRequest(request: ReducerAction) {
	const { payload }: { payload: CadastroConsultaRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`atendimentos-de-consulta/${CHANNEL}/cria-atendimentos-de-consulta`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(cadastroConsultaSuccess({ request: payload, response }));
	} else {
		yield put(cadastroConsultaFailure(response));
	}
}

export default all([
	takeLatest(Types.CADASTRO_CONSULTA_REQUEST, cadastroConsultaRequest),
]);
